module.exports = __webpack_public_path__ + "static/img/avatar48px_qy@2x.2176f7a3.png";